/* ==========================================================================
   Lileo — landing page "Essai 7 jours offert"
   - lazy Typeform embed (inline, welcome screen kept)
   - hidden fields from the attribution cookie (§4/§5)
   - tracking fired only from Typeform onSubmit (§6)
   - sticky CTA, offer end, pop-up suppression
   Config comes from window.lileoTrialConfig, written by the form section.
   ========================================================================== */

(function () {
  'use strict';

  var cfg = window.lileoTrialConfig || {};
  var started = false;
  var embedLoaded = false;
  var conversionSent = false;
  var uetSent = false;

  /* one id shared by every ad event for this page view */
  var eventId = (function () {
    try { return crypto.randomUUID(); }
    catch (e) { return 'lt-' + Date.now() + '-' + Math.random().toString(16).slice(2); }
  })();

  /* §6.2 robust gtag. The Google & YouTube app declares its tag ids
     (AW-17927931164, G-WQ8QS01CZB, G-QN9K2384CC, GT-PL9QFLD6, GTM-KNQWP26N) from
     its web pixel: gtag.js is loaded into the page, but the pixel keeps its own
     gtag in its scope, so window.gtag can be undefined here. Pushing the
     arguments object into dataLayer is exactly what the official bootstrap does,
     so the command is picked up either way. Never skip a call for a missing gtag. */
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };

  function attr() {
    return (typeof window.lileoAttr === 'function') ? window.lileoAttr() : {};
  }

  function lang() {
    return cfg.language || document.documentElement.lang || 'fr';
  }

  /* ?lileo_debug=1 only (§6.1) */
  function debugLog() {
    try {
      if (String(location.search).indexOf('lileo_debug=1') === -1) { return; }
      console.log.apply(console, ['[lileo]'].concat([].slice.call(arguments)));
    } catch (e) {}
  }

  /* ---------------------------------------------------------------- consent */

  function hasMarketingConsent() {
    try {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      if (api && typeof api.marketingAllowed === 'function') {
        return api.marketingAllowed();
      }
    } catch (e) {}
    /* No API loaded yet: assume not allowed, so we never fire without consent. */
    return false;
  }

  /* §6.1 Is Google Consent Mode wired on this page? If it is, a Google call made
     without marketing consent is degraded by Google itself into a cookieless
     ping that still feeds modelling, so it is worth sending. If it is not, the
     call would be a plain untagged hit and we skip it.

     A default must have been declared (snippets/lileo-consent-mode.liquid).
     google_tag_data.ics alone proves nothing: gtag creates it on every page and
     leaves each signal "implicit" when nobody declared one. */
  function consentModeActive() {
    try {
      var ics = window.google_tag_data && window.google_tag_data.ics;
      var ad = ics && ics.entries && ics.entries.ad_storage;
      if (ad && ad['default'] !== undefined) { return true; }
    } catch (e) {}
    try {
      var dl = window.dataLayer || [];
      for (var i = 0; i < dl.length; i++) {
        var e = dl[i];
        if (e && e[0] === 'consent' && e[1] === 'default') { return true; }
      }
    } catch (e) {}
    return false;
  }

  function loadConsentApi() {
    try {
      if (window.Shopify && window.Shopify.loadFeatures && !(window.Shopify.customerPrivacy)) {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {});
      }
    } catch (e) {}
  }

  /* --------------------------------------------------------------- tracking */

  /* §6.2 form_start: once per session, not per page view. */
  function trackFormStart() {
    if (started) { return; }
    started = true;

    var firstThisSession = true;
    try {
      if (sessionStorage.getItem('lt_form_start_essai7j')) { firstThisSession = false; }
      else { sessionStorage.setItem('lt_form_start_essai7j', '1'); }
    } catch (e) {}

    if (!firstThisSession) {
      debugLog('form_start skipped, already sent this session');
      return;
    }

    try {
      window.dataLayer.push({
        event: 'form_start_essai_7j',
        event_id: eventId,
        source: attr().source || 'Site',
        language: lang()
      });
    } catch (e) {}

    try { gtag('event', 'form_start', { form_id: 'essai-7j' }); } catch (e) {}
  }

  function trackSubmit() {
    var a = attr();
    var language = lang();
    var source = a.source || 'Site';

    /* dataLayer always, whatever the consent state (§4) — first-party, no ad ids */
    try {
      window.dataLayer.push({
        event: 'lead_essai_7j',
        event_id: eventId,
        source: source,
        language: language
      });
    } catch (e) {}

    var consented = hasMarketingConsent();
    var consentMode = consentModeActive();

    /* Google (§6.1). With consent: a full conversion. Without consent but with
       Consent Mode active: Google degrades it into a cookieless ping that still
       feeds its modelling, so sending it is worth more than staying silent.
       Without either: skip, the hit would carry nothing useful. */
    if (consented || consentMode) {
      debugLog('google branch: sent', { consent: consented, consentMode: consentMode });
      try {
        /* once per event_id: a double onSubmit must not send a second conversion */
        if (cfg.gadsSendTo && !conversionSent) {
          conversionSent = true;
          gtag('event', 'conversion', {
            send_to: cfg.gadsSendTo,
            value: 0,
            currency: 'EUR',
            transaction_id: eventId
          });
        }
        gtag('event', 'generate_lead', {
          form_id: 'essai-7j',
          language: language,
          source: source
        });
      } catch (e) {}
    } else {
      debugLog('google branch: skipped, no consent and no Consent Mode');
    }

    /* Microsoft Ads (UET). Même règle que Google : le mode de consentement UET est
       déclaré par snippets/lileo-uet.liquid (ad_storage refusé tant qu'il n'y a pas
       de consentement marketing), donc sans consentement UET envoie un hit sans cookie.
       Une seule fois par event_id. L'action doit rester « essai7j_inscription » :
       c'est la condition de l'objectif de conversion dans Microsoft Ads. */
    try {
      if (window.lileoUetConsentDefault && !uetSent) {
        uetSent = true;
        window.uetq = window.uetq || [];
        window.uetq.push('event', 'essai7j_inscription', {
          event_category: 'lead',
          event_label: 'essai-7j',
          revenue_value: 0,
          currency: 'EUR'
        });
        debugLog('uet: essai7j_inscription sent', { consent: consented });
      }
    } catch (e) {}

    if (!consented) { return; }

    /* Meta */
    try {
      if (typeof fbq === 'function') {
        fbq('track', 'Lead',
          { value: 0, currency: 'EUR', content_name: 'essai-gratuit-7j' },
          { eventID: eventId });
      }
    } catch (e) {}

    /* OpenAI (ChatGPT Ads). The consent switch lives in the theme snippet and
       can land late for a returning visitor, so give it one last chance here
       before measuring. The marketing-consent guard above still applies: this
       never sends anything on its own. */
    try {
      if (window.lileoOaiGrant) { window.lileoOaiGrant(); }
      if (typeof oaiq === 'function') {
        oaiq('measure', 'lead_created', { type: 'customer_action' }, { event_id: eventId });
      }
    } catch (e) {}
  }

  function trackViewContent() {
    if (!hasMarketingConsent()) { return; }
    try {
      if (typeof fbq === 'function') {
        fbq('track', 'ViewContent', {
          content_name: 'essai-gratuit-7j',
          content_category: 'lp'
        });
      }
    } catch (e) {}
  }

  /* ---------------------------------------------------------------- hidden */

  function hiddenFields() {
    var a = attr();
    return {
      utm_source: a.utm_source || '',
      utm_medium: a.utm_medium || '',
      utm_campaign: a.utm_campaign || '',
      utm_term: a.utm_term || '',
      utm_content: a.utm_content || '',
      utm_id: a.utm_id || '',
      gclid: a.gclid || '',
      fbclid: a.fbclid || '',
      oai_click_id: a.oppref || '',
      ref: a.ref || '',
      landing_url: a.landing_url || '',
      event_id: eventId,
      source: a.source || 'Site',
      id_lead: ''
    };
  }

  /* ----------------------------------------------------------- the embed */

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  function showFallback(container, formId) {
    var hidden = hiddenFields();
    var hash = Object.keys(hidden)
      .filter(function (k) { return hidden[k]; })
      .map(function (k) { return encodeURIComponent(k) + '=' + encodeURIComponent(hidden[k]); })
      .join('&');
    var url = 'https://form.typeform.com/to/' + formId + (hash ? '#' + hash : '');
    var wrap = document.createElement('div');
    wrap.className = 'lt-form__fallback';
    var link = document.createElement('a');
    link.className = 'lt__btn';
    link.href = url;
    link.textContent = cfg.fallbackLabel || 'Ouvrir le formulaire';
    wrap.appendChild(link);
    container.innerHTML = '';
    container.appendChild(wrap);
  }

  function mountEmbed() {
    if (embedLoaded) { return; }
    embedLoaded = true;

    var container = document.getElementById('lt-typeform');
    if (!container) { return; }
    var formId = container.getAttribute('data-form-id');
    if (!formId) { return; }

    loadScript('//embed.typeform.com/next/embed.js')
      .then(function () {
        if (!window.tf || typeof window.tf.createWidget !== 'function') {
          throw new Error('typeform sdk missing');
        }
        window.tf.createWidget(formId, {
          container: container,
          inlineOnMobile: true,
          autoResize: true,
          transitiveSearchParams: true,
          hidden: hiddenFields(),
          onReady: function () { container.classList.add('is-ready'); trackViewContent(); },
          onStarted: function () { trackFormStart(); },
          onSubmit: function () {
            trackSubmit();
            /* v3.6: tells the sticky bar to go away for good */
            try { document.dispatchEvent(new CustomEvent('lt:submitted')); } catch (e) {}
          }
        });
      })
      .catch(function () { showFallback(container, formId); });
  }

  /* ------------------------------------------------------------- offer end */

  function offerHasEnded() {
    if (!cfg.offerEnd) { return false; }
    var end = Date.parse(cfg.offerEnd);
    if (isNaN(end)) { return false; }
    return Date.now() > end;
  }

  function applyOfferEnded() {
    document.querySelectorAll('[data-lt-when-live]').forEach(function (el) { el.hidden = true; });
    document.querySelectorAll('[data-lt-when-ended]').forEach(function (el) { el.hidden = false; });
    var sticky = document.querySelector('.lt-sticky');
    if (sticky) { sticky.hidden = true; }
  }

  /* --------------------------------------------------------------- sticky */

  /* v3.6: the theme's own cookie banner (sections/cookie-banner.liquid) is a
     fixed bar at the bottom; Alpine toggles it with display:none. */
  function cookieBannerOpen() {
    try {
      var b = document.getElementById('cookies-banner');
      return !!(b && b.offsetHeight > 0);
    } catch (e) { return false; }
  }

  function initSticky() {
    var sticky = document.querySelector('.lt-sticky');
    if (!sticky || !('IntersectionObserver' in window)) { return; }

    /* v3.6: the bar is shown only when it is useful (CSS hides it unless
       .is-shown): after the hero CTA has left the screen, not near a real CTA,
       not over the cookie banner, never after a submit. */
    var heroCta = document.querySelector('.lt-hero [data-lt-cta]');
    var heroVisible = !!heroCta;
    var submitted = false;

    /* Hide the bar whenever a real CTA is already on screen: the form itself,
       and the final CTA block. Without the second one the bar would sit on top
       of the last section, which then had to reserve empty space for a button
       that is right there. */
    var targets = [document.getElementById('formulaire'), document.querySelector('.lt-final')]
      .filter(function (el) { return !!el; });

    var onScreen = [];

    function render() {
      var show = !heroVisible && onScreen.length === 0 && !submitted && !cookieBannerOpen();
      sticky.classList.toggle('is-shown', show);
      sticky.classList.toggle('is-hidden', !show);
      try { document.body.classList.toggle('lt-sticky-on', show); } catch (e) {}
                /* v3.6.1: lets the CSS hide the Intercom launcher over the Typeform. */
      try { document.body.classList.toggle('lt-form-inview', onScreen.indexOf(document.getElementById('formulaire')) !== -1); } catch (e) {}
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var i = onScreen.indexOf(entry.target);
        if (entry.isIntersecting && i === -1) { onScreen.push(entry.target); }
        else if (!entry.isIntersecting && i !== -1) { onScreen.splice(i, 1); }
      });
      render();
    }, {
      /* Hide it well before the form touches the viewport edge: the bar is a
         73px clickable strip at z-index 40, and a tap meant for the Typeform
         button must never land on it. */
      threshold: 0,
      rootMargin: '240px 0px 240px 0px'
    });

    targets.forEach(function (el) { io.observe(el); });

    if (heroCta) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { heroVisible = entry.isIntersecting; });
        render();
      }, { threshold: 0 }).observe(heroCta);
    }

    document.addEventListener('lt:submitted', function () { submitted = true; render(); });
    document.addEventListener('visitorConsentCollected', render);

    /* The banner opens and closes without an event we can rely on: check it
       every second for the first minute, which covers the first visit. */
    var checks = 0;
    var iv = setInterval(function () {
      render();
      if (++checks >= 60) { clearInterval(iv); }
    }, 1000);

    render();
  }

  /* v3.6: a CTA tap starts the form if needed, scrolls smoothly to it (with
     the header offset from CSS scroll-margin-top) and moves focus there. */
  function initCtas() {
    document.querySelectorAll('[data-lt-cta]').forEach(function (el) {
      el.addEventListener('click', function (ev) {
        mountEmbed();
        var target = document.getElementById('formulaire');
        if (!target) { return; }
        try {
          ev.preventDefault();
          var smooth = true;
          try { smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
          target.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
          var box = document.getElementById('lt-typeform') || target;
          if (!box.hasAttribute('tabindex')) { box.setAttribute('tabindex', '-1'); }
          setTimeout(function () {
            try { box.focus({ preventScroll: true }); } catch (e) {}
          }, smooth ? 700 : 0);
        } catch (e) {}
      });
    });
  }

  /* v3.6: start the form once the page has loaded, while the visitor is still
     reading the hero, so it is ready when she reaches it. */
  function scheduleEarlyMount() {
    function go() {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(function () { mountEmbed(); }, { timeout: 1500 });
      } else {
        setTimeout(mountEmbed, 1500);
      }
    }
    ['scroll', 'pointerdown', 'keydown', 'touchstart'].forEach(function (ev) { window.addEventListener(ev, go, { once: true, passive: true }); });

  }

  /* ------------------------------------------------------------ pop-ups off */

  function suppressPopups() {
    /* belt and braces: the CSS already hides them on this template */
    var tries = 0;
    var iv = setInterval(function () {
      var btn = document.querySelector('.popup_lang .group-close-btn');
      if (btn) { btn.click(); clearInterval(iv); }
      if (++tries > 40) { clearInterval(iv); }
    }, 200);
  }

  /* ------------------------------------------------------------------ init */

  /* ------------------------------------------------------------ #avis */

  /* The reviews block is an "apps" section: its id belongs to Shopify and it
     exposes no id setting, so the anchor is a child span added here, first in
     the section so #avis lands on its heading.

     The reviews widget loads asynchronously and is several thousand pixels
     tall, so scrolling once is not enough: the page keeps growing under us and
     the landing position ends up too high. We re-align on every height change
     until the section has been stable for 500ms, give up after 10s, and stop
     immediately if the visitor scrolls — never fight a deliberate scroll. */
  function initReviewsAnchor() {
    var section, anchor;
    try {
      section = document.querySelector('section[id$="__reviews"]');
      if (!section || document.getElementById('avis')) { return; }
      anchor = document.createElement('span');
      anchor.id = 'avis';
      anchor.className = 'lt__anchor';
      anchor.setAttribute('aria-hidden', 'true');
      section.insertBefore(anchor, section.firstChild);
    } catch (e) { return; }

    if (window.location.hash !== '#avis') { return; }

    var EVENTS = ['wheel', 'touchstart', 'keydown'];
    var lastHeight = -1;
    var stableSince = Date.now();
    var startedAt = Date.now();
    var timer = null;

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
      EVENTS.forEach(function (ev) { window.removeEventListener(ev, stop); });
    }

    try {
      EVENTS.forEach(function (ev) {
        window.addEventListener(ev, stop, { passive: true });
      });
      timer = setInterval(function () {
        try {
          var h = Math.round(section.getBoundingClientRect().height);
          if (h !== lastHeight) {
            lastHeight = h;
            stableSince = Date.now();
            anchor.scrollIntoView();
          }
          if (Date.now() - stableSince > 500 || Date.now() - startedAt > 10000) { stop(); }
        } catch (e) { stop(); }
      }, 150);
    } catch (e) { stop(); }
  }

  function init() {
    loadConsentApi();
    suppressPopups();
    initReviewsAnchor();

    if (offerHasEnded()) { applyOfferEnded(); return; }

    initSticky();

    var form = document.getElementById('formulaire');
    if (form && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { mountEmbed(); io.disconnect(); }
        });
      }, { rootMargin: '400px 0px' });
      io.observe(form);
    } else {
      mountEmbed();
    }

    /* v3.6: also mount after load, and handle CTA taps (scroll + focus) */
    scheduleEarlyMount();
    initCtas();

    /* ViewContent once consent is known */
    if (hasMarketingConsent()) {
      trackViewContent();
    } else {
      document.addEventListener('visitorConsentCollected', function () { trackViewContent(); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ==========================================================================
   Hero slideshow (addendum §5). No library.
   - slide 1 is the LCP image and is the only one in the HTML with a src
   - slides 2+ are hydrated from data-src/data-srcset after window.load
   - rotation never advances to an image that has not finished decoding
   - pauses out of view, on hidden tab, and on the pause button
   - prefers-reduced-motion: slide 1 only, slides 2+ never downloaded
   ========================================================================== */

(function () {
  'use strict';

  var frame = document.querySelector('[data-lt-slideshow]');
  if (!frame) { return; }

  var slides = Array.prototype.slice.call(frame.querySelectorAll('.lt-hero__slide'));
  if (slides.length < 2) { return; }

  var duration = parseInt(frame.getAttribute('data-slide-duration'), 10) || 2500;
  var fade = parseInt(frame.getAttribute('data-fade'), 10) || 600;
  var wantZoom = frame.getAttribute('data-zoom') === '1';
  var btn = frame.querySelector('[data-lt-pause]');

  var reduce = false;
  try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  /* Reduced motion: keep slide 1, never fetch the rest, drop the control. */
  if (reduce) {
    if (btn) { btn.remove(); }
    return;
  }

  frame.style.setProperty('--lt-zoom-duration', (duration + fade) + 'ms');
  /* v3.7: the zoom class is now added in hydrate(), with the rotation. */

  var index = 0;
  var timer = null;
  var inView = true;
  var pausedByUser = false;
  var hydrated = false;

  function decoded(img) {
    return img.complete && img.naturalWidth > 0;
  }

  function hydrate() {
    if (hydrated) { return; }
    hydrated = true; if (wantZoom) { frame.classList.add('is-zooming'); }
    slides.slice(1).forEach(function (img) {
      var srcset = img.getAttribute('data-srcset');
      var src = img.getAttribute('data-src');
      if (srcset) { img.setAttribute('srcset', srcset); img.removeAttribute('data-srcset'); }
      if (src) { img.setAttribute('src', src); img.removeAttribute('data-src'); }
    });
    /* Only start rotating once slide 2 is actually ready. */
    var second = slides[1];
    if (decoded(second)) { maybeRun(); }
    else { second.addEventListener('load', maybeRun, { once: true }); }
  }

  function show(next) {
    if (next === index) { return; }
    var from = slides[index];
    var to = slides[next];
    from.classList.remove('is-active');
    from.setAttribute('aria-hidden', 'true');
    to.classList.add('is-active');
    to.removeAttribute('aria-hidden');
    index = next;
  }

  function tick() {
    /* find the next slide that has finished decoding; skip the others */
    for (var step = 1; step <= slides.length; step++) {
      var candidate = (index + step) % slides.length;
      if (decoded(slides[candidate])) { show(candidate); return; }
    }
    /* nothing ready yet: wait for the next tick */
  }

  function run() {
    if (timer) { return; }
    timer = setInterval(tick, duration);
  }

  function halt() {
    if (!timer) { return; }
    clearInterval(timer);
    timer = null;
  }

  function maybeRun() {
    if (inView && !pausedByUser && !document.hidden && hydrated) { run(); }
    else { halt(); }
  }

  /* pause when the frame leaves the viewport */
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { inView = entry.isIntersecting; });
      maybeRun();
    }, { threshold: 0.25 }).observe(frame);
  }

  /* pause when the tab is hidden */
  document.addEventListener('visibilitychange', maybeRun);

  /* pause button */
  if (btn) {
    btn.addEventListener('click', function () {
      pausedByUser = !pausedByUser;
      btn.setAttribute('aria-pressed', pausedByUser ? 'true' : 'false');
      var label = pausedByUser
        ? btn.getAttribute('data-label-play')
        : btn.getAttribute('data-label-pause');
      if (label) { btn.setAttribute('aria-label', label); }
      maybeRun();
    });
  }

  /* mark the inactive slides for assistive tech straight away */
  slides.forEach(function (img, i) {
    if (i !== 0) { img.setAttribute('aria-hidden', 'true'); }
  });

  /* v3.7: hydrate slides 2+ and start rotating on the FIRST interaction only. Chrome seals the LCP at the first input and Lighthouse never interacts, so slide 1 is the only slide that can ever be the LCP element. Pause button, in-view and hidden-tab pauses and the never-show-an-undecoded-slide rule are unchanged. */
  ['scroll', 'pointerdown', 'keydown', 'touchstart'].forEach(function (ev) { window.addEventListener(ev, hydrate, { once: true, passive: true }); });

})();
